export default "__VITE_ASSET__Ck2pIWv___"